export const HELP_CENTER_TRANSLATION_KEY = 'ExpondoHelpCenter';
